import React, { useEffect } from "react";
import "./Career_Support.css";
import { useDispatch, useSelector } from "react-redux";
import { AllMentors } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

// ✅ Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

import { Autoplay, Navigation } from "swiper/modules";

const Career_Support = () => {
  const dispatch = useDispatch();
  const mentors = useSelector((state) => state?.common?.all_mentors);

  useEffect(() => {
    dispatch(AllMentors());
  }, [dispatch]);

  return (
    <section className="Career_Support Industry_Experts">
      <div className="container">
        <div className="Career_Support_header">
          <h5 className="Career_Support_title">
            Mentorship & <span> Career Support </span>
          </h5>

          <p className="title_text">
            You will learn directly from experienced industry professionals who
            guide you throughout the program with real-world insights, doubt
            solving, and execution-focused teaching. Along with technical
            training, you receive structured career support including resume
            improvement, mock interviews, and preparation for real hiring
            scenarios.
          </p>
        </div>

        {/* ✅ Swiper Starts */}
        <div className="expert_team_div">
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={4}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            // navigation={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
            }}
          >
            {mentors?.map((member) => (
              <SwiperSlide key={member.id}>
                <div className="member_wrapper">
                  <div className="expert_img_holder">
                    <img
                      src={`${IDS.IMG_URL}${member.image}`}
                      alt={member.name}
                      className="expert_img"
                    />
                  </div>

                  <div className="expert_info_section">
                    <div className="expert_div">
                      <p className="expert_name">{member.name}</p>

                      {member.social_links && member.social_links.icon && (
                        <div className="social_div">
                          <a
                            href={member.social_links.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${IDS.IMG_URL}${member.social_links.icon}`}
                              alt={member.social_links.name}
                              className="social_icon"
                            />
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="desg_holder">
                      <p className="designation">{member.education}</p>

                      <div className="company_logo_div">
                        <img
                          src={`${IDS.IMG_URL}${member.companylogo}`}
                          alt="logo"
                          className="company_logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Career_Support;